export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      const offset = 80;
      const elementPosition = element.getBoundingClientRect().top;
      const offsetPosition = elementPosition + window.pageYOffset - offset;
      window.scrollTo({
        top: offsetPosition,
        behavior: 'smooth'
      });
    }
  };

  return (
    <footer className="bg-gradient-to-br from-gray-900 via-gray-800 to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          <div className="md:col-span-2">
            <img 
              src="https://static.readdy.ai/image/53582753cc50d08d0a8300a8f3dad6b7/28ce903ceaaf15cb653f91e3ac9d0a25.jpeg" 
              alt="Cobramas Production" 
              className="h-16 w-auto mb-6"
            />
            <p className="text-sm text-gray-300 mb-6 leading-relaxed">
              <strong className="text-white">Cobramas Production</strong> adalah produsen terpercaya material bangunan berbahan beton berkualitas tinggi di Boyolali. Kami menyediakan batako, paving block, roster beton, kanstin, dan produk beton pracetak lainnya untuk mendukung kesuksesan proyek konstruksi Anda.
            </p>
            <div className="flex gap-3">
              <a 
                href="https://wa.me/6285642080427"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 bg-orange-600 rounded-lg flex items-center justify-center hover:bg-orange-700 transition-colors"
              >
                <i className="ri-whatsapp-line text-xl"></i>
              </a>
              <a 
                href="tel:+6285642080427"
                className="w-10 h-10 bg-orange-600 rounded-lg flex items-center justify-center hover:bg-orange-700 transition-colors"
              >
                <i className="ri-phone-line text-xl"></i>
              </a>
            </div>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Menu</h3>
            <ul className="space-y-3">
              <li>
                <button 
                  onClick={() => scrollToSection('hero')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Beranda
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Tentang Kami
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('products')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Produk
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('advantages')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Keunggulan
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('gallery')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Galeri
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  Kontak
                </button>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-bold mb-6">Kontak</h3>
            <ul className="space-y-4">
              <li className="flex items-start gap-3">
                <i className="ri-map-pin-line text-orange-400 mt-1 flex-shrink-0"></i>
                <span className="text-sm text-gray-300 leading-relaxed">
                  Jl. Raya Pandeyan, Garen, Pandeyan, Kec. Ngemplak, Kab. Boyolali, Jawa Tengah 57375
                </span>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-phone-line text-orange-400 flex-shrink-0"></i>
                <a 
                  href="tel:+6285642080427"
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  085642080427
                </a>
              </li>
              <li className="flex items-center gap-3">
                <i className="ri-whatsapp-line text-orange-400 flex-shrink-0"></i>
                <a 
                  href="https://wa.me/6285642080427"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-sm text-gray-300 hover:text-orange-400 transition-colors"
                >
                  WhatsApp
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-gray-700 mt-12 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-sm text-gray-400">
              &copy; 2025 Cobramas Production. All rights reserved.
            </p>
            <a 
              href="https://readdy.ai/?ref=logo"
              target="_blank"
              rel="noopener noreferrer"
              className="text-sm text-gray-400 hover:text-orange-400 transition-colors"
            >
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}